import type { EventCatalog } from "./events";
import { dispatch } from "./providers";

const PREFIX = "px";

export function track<E extends keyof EventCatalog>(
  event: E,
  properties: EventCatalog[E]
) {
  dispatch(`${PREFIX}.${event}`, { ...properties });
}
